import { authHeader, handleResponse } from '../helpers'

export const customerService = {
    getCustomers,
    getCustomer,
    createCustomer,
    editCustomer,
    deleteCustomer,
    syncCustomers,
};

function getCustomers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/customer`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function getCustomer(customerId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/customer/${customerId}`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function createCustomer(customerData) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: customerData
    };
    return fetch(process.env.VUE_APP_API_URL + `/customer`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}

function editCustomer(customerId, customerData) {
    const requestOptions = {
        method: 'PUT',
        headers: authHeader(),
        body: customerData
    };
    return fetch(process.env.VUE_APP_API_URL + `/customer/${customerId}`, requestOptions)
    .then(response => {
        return response;
    });
}

function deleteCustomer(customerId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };
    return fetch(process.env.VUE_APP_API_URL + `/customer/${customerId}`, requestOptions)
    .then(response => response.text())
    .then(response => {
        return response;
    });
}

function syncCustomers() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };
    return fetch(process.env.VUE_APP_API_URL + `/customer/sync`, requestOptions)
    .then(handleResponse)
    .then(response => {
        return response;
    });
}
